import React from "react";
import "./SidebarChat.css";
import { Avatar } from "@material-ui/core";

const SidebarChat = ({ _id, roomName, lastmessage }) => {
  return (
    <div className="sidebarChat" key={_id}>
      <Avatar />
      <div className="sidebarChat__info">
        <h2>{roomName}</h2>
        <p>{lastmessage && lastmessage.message}</p>
      </div>
    </div>
  );
};

export default SidebarChat;
